import React from 'react';
import styled from 'styled-components';
import { Formik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { getTranslatedString, getTranslatedName } from 'helpers/i18n';
import Property from './fields/Property';
import BatchName from './fields/BatchName';
import Description from './fields/Description';
import Spacer from 'components/ui/Spacer';
import { VerticalFormWrapper } from 'components/ui/VerticalFormWrapper';

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const StyledText = styled.p`
  font-size: 14px;
`;

const BatchForm = ({ formName, formData, handleSubmit, showBottomInfoText = true }) => {
  const validateForm = async (values) => {
    const requiredErrorVerbiage = getTranslatedString('required');
    let validationSchema = {
      property_id: Yup.string().required(requiredErrorVerbiage),
      name: Yup.string()
        .required(requiredErrorVerbiage)
        .max(50, getTranslatedString('landlordPortal.batches.lessThan50')),
    };
    const schema = Yup.object().shape(validationSchema);
    return schema.validate(values, { abortEarly: false }).catch((error) => {
      throw yupToFormErrors(error);
    });
  };

  const translatedName = getTranslatedName(formData.name) || undefined;
  const translatedDescription = getTranslatedName(formData.description) || undefined;

  const initialValues = {
    id: formData.id || undefined,
    property_id: formData.property_id,
    name: translatedName,
    description: translatedDescription,
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validateForm}
      enableReinitialize
    >
      {({ handleSubmit, ...rest }) => (
        <VerticalFormWrapper id={formName} onSubmit={handleSubmit}>
          <Property {...rest} disabled={formName === 'edit_batch_form'} />
          <BatchName {...rest} />
          <Description {...rest} />
          {showBottomInfoText && (
            <Spacer mb={0.5}>
              <StyledTitle>
                {getTranslatedString('landlordPortal.batches.addingPaymentsTitle')}
              </StyledTitle>
              <StyledText>
                {getTranslatedString('landlordPortal.batches.addingPaymentsBody')}
              </StyledText>
            </Spacer>
          )}
        </VerticalFormWrapper>
      )}
    </Formik>
  );
};

export default BatchForm;
